import './WebModules'
import './polyfills'
import React, { useEffect } from 'react';
import {AppRegistry, View} from 'react-native';
import WebRouter from './WebRouter';
import Toast from "../Mobile-mmt-react-native/packages/legacy-commons/Common/Components/Toast2";
import {initAbConfig} from '../Mobile-mmt-react-native/packages/legacy-commons/Native/AbConfig/AbConfigModule'
import { loadableReady } from '@loadable/component';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import store from './webStore';
import { Provider } from "react-redux";
import AppWithLang from './AppWithLang';
import useConfigStore, {
  initRailsConfigStore
} from "../Mobile-mmt-react-native/apps/rails/src/configStore/Common/RailsConfigStoreUtils";
import { configKeys } from '../Mobile-mmt-react-native/apps/rails/src/configStore/Common/constants';
import { fetchRisOptions } from '../Mobile-mmt-react-native/apps/rails/src/pages/RailsLandingPage/Store/RailsLandingPageActions';
import * as Sentry from "@sentry/react";
import { getCookieKeyBy } from '../Mobile-mmt-react-native/apps/rails/src/Utils/mwebHeaders';
import md5 from 'md5';
import { initAdobeDataLayerMMT } from '@mmt/event-logger';
import { XDMWrapper } from '@gt-common/event-logger-web';



const history = createBrowserHistory();
window.mmtHistory = history;

const isTrackingEnabled = () => {
  const trackCookie = document.cookie.split('; ').find(row => row.startsWith('track='));
  return trackCookie ? trackCookie.split('=')[1] === 'true' : true;
};

const setTrackingCookie = (enabled = true) => {
  document.cookie = `track=${enabled}; path=/; max-age=86400`;
};

export const AnalyticsSdk = XDMWrapper.initAndSetAnalyticsSdk({
  org: 'MMT'
});

if (typeof window !== 'undefined') {
  window.setTrackingCookie = setTrackingCookie;
  window.isTrackingEnabled = isTrackingEnabled;
  window.AnalyticsSdk = AnalyticsSdk;
}

initAbConfig()
store.dispatch(fetchRisOptions())
initRailsConfigStore();

if(!__DEV__){
  Sentry.init({
    release: 'mweb-sync-1.0.7',
    dsn: "https://d21989510b063c73ac03ea8f208e0cd0@o162542.ingest.us.sentry.io/4507485020028928",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.extraErrorDataIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}


const App = () => {
  const enableClarityScript = useConfigStore(configKeys.ENABLE_CLARITY_SCRIPT);
  useEffect(() => {
    if (enableClarityScript === true) {
      createClarityScript();
    }

    const trackingEnabled = isTrackingEnabled();
    
    if (!trackingEnabled) {
      return;
    }

    try {
      const scriptHtml = initAdobeDataLayerMMT(__DEV__ ? 'development' : 'production');
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = scriptHtml;
      const scriptElement = tempDiv.querySelector('script');
      
      if (scriptElement && scriptElement.src) {
        const existingScript = document.querySelector(`script[src="${scriptElement.src}"]`);
        if (existingScript) {
          return;
        }
        
        const newScript = document.createElement('script');
        newScript.src = scriptElement.src;
        newScript.async = scriptElement.async || true;
        
        newScript.onload = () => {

        };
        
        newScript.onerror = (error) => {
          
        };
        
        document.head.appendChild(newScript);
      }
      
    } catch (error) {
      console.error('Error initializing Adobe Data Layer:', error);
    }
  }, [enableClarityScript]);

  return (
    <Provider store={store}>
      <AppWithLang>
        <Router history={history} forceRefresh>
          <WebRouter />
          <Toast />
        </Router>
      </AppWithLang>
    </Provider>
  );
};

const injectClarityHtml = () => {
  const cookieKeyBy = getCookieKeyBy();
  const userId = `${(cookieKeyBy?.["mmt-uuid"] ? md5(cookieKeyBy["mmt-uuid"]) : null) || (cookieKeyBy?.["dvid"] ? md5(cookieKeyBy["dvid"]) : null) || "nil"}`;
  return `
(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    clarity("set", "test", "${userId}");
})(window, document, "clarity", "script", "i89xssolfr");`};

const rootElement = window.document.getElementById('react-root');
rootElement.innerHTML = '';

export const createClarityScript = () => {
  const scriptTag = document.createElement('script');
  scriptTag.innerHTML = injectClarityHtml();
  window.document.head.appendChild(scriptTag)
}

loadableReady(() => {
  AppRegistry.registerComponent('MmtReactNative', () => App);
  AppRegistry.runApplication('MmtReactNative', {
    rootTag: rootElement,
    hydrate: false,
  });
})


if (window) {
  if ('serviceWorker' in window.navigator) {
    window.addEventListener('load', () => {
      window.navigator.serviceWorker.register('/pwa/v2/service-worker.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
}

